import { ContentHeaderModel } from "./contentHeaderModel";

export const ContentHeader = ({
  title,
  children,
  className,
}: ContentHeaderModel) => {
  return (
    <div
      className={
        "content-header" + (className !== undefined ? " " + className : "")
      }
    >
      <h3>{title}</h3>
      <div className="content-header-actions">{children}</div>
    </div>
  );
};
